import React from "react";
import { saveAs } from "file-saver";
import FontFa from "../../../../components/fontFa/fontFa";
import {
  AlignmentType,
  BorderStyle,
  Document,
  Header,
  HeightRule,
  ImageRun,
  Packer,
  PageNumber,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  VerticalMergeType,
  WidthType,
  convertInchesToTwip,
} from "docx";
import { C, text } from "../../../procedure/company-office/request-vehicle/TemplateDocx/Template/common";
import { CreateNotification } from "../../../../components/notifier";
import { logoBase64 } from "../../../procedure/info-technology-process/repair-tools/base64";
import { useEmployee } from "../../../../hook";
export const WordTemplateItems = (props: any) => {
  const { document } = props;
  const {getEmployeesByEmail} = useEmployee();

  const docCheckerEmail = document?.docCheckers?.find((e: any) => e.isDone)?.email;
  const docChecker = getEmployeesByEmail(docCheckerEmail);

  const docTempate = new Document({
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: convertInchesToTwip(1),
              bottom: convertInchesToTwip(1),
              left: convertInchesToTwip(1),
              right: convertInchesToTwip(1),
            },
          },
        },
        headers: {
          default: new Header({
            children: [
              new Table({
                width: {
                  size: "100%",
                  type: WidthType.PERCENTAGE,
                },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(30, [
                          new Paragraph({
                            children: [
                              new ImageRun({
                                data: logoBase64,
                                transformation: {
                                  width: 150,
                                  height: 40,
                                },
                              }),
                            ],
                            alignment: AlignmentType.CENTER,
                          }),
                        ]),
                        verticalAlign: VerticalAlign.CENTER,
                        rowSpan: 4,
                      }),

                      new TableCell({
                        ...C.col(40, [text({ size: 24, text: "Biểu mẫu", italics: true })]),
                        borders: { bottom: { style: BorderStyle.NIL } },
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                      new TableCell({
                        ...C.col(30, [text({ size: 24, text: "Mã số: V.QMS-F01" })]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                    height: {
                      value: 800,
                      rule: HeightRule.AUTO,
                    },
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(44, [
                          text({ size: 28, text: "PHIẾU YÊU CẦU", bold: true }, { alignment: AlignmentType.CENTER }),
                          text(
                            { size: 28, text: "SOẠN THẢO/CHỈNH SỬA/", bold: true },
                            { alignment: AlignmentType.CENTER },
                          ),
                          text({ size: 28, text: "HỦY BỎ TÀI LIỆU", bold: true }, { alignment: AlignmentType.CENTER }),
                        ]),
                        rowSpan: 3,
                        borders: { top: { style: BorderStyle.NIL } },
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                        verticalMerge: VerticalMergeType.RESTART,
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        ...C.col(30, [text({ size: 24, text: "Ban hành: 01" })]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                    height: {
                      value: 500,
                      rule: HeightRule.AUTO,
                    },
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(30, [text({ size: 24, text: "Hiệu lực: 10/07/2022" })]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(33, [
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: "Trang: ",
                                size: 24,
                              }),
                              new TextRun({
                                children: [PageNumber.CURRENT, "/", PageNumber.TOTAL_PAGES],
                                size: 24,
                              }),
                            ],
                          }),
                        ]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new Paragraph(""),
            ],
          }),
        },
        children: [
          new Table({
            width: {
              size: "100%",
              type: WidthType.PERCENTAGE,
            },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [
                      text({ size: 24, text: "PHẦN YÊU CẦU", bold: true }, { alignment: AlignmentType.CENTER }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    shading: {
                      fill: "e6e6e6",
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [
                      text({ size: 24, text: `Cơ quan/đơn vị đề xuất yêu cầu: ${document.docPublicDepartment}` }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [text({ size: 24, text: `□ Soạn thảo mới tài liệu về vấn đề: ${document.Title}` })]),
                    margins: {
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    borders: {
                      bottom: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(50, [text({ size: 24, text: `□ Sửa đổi tài liệu (mã số): ${document.docCode}` })]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    borders: {
                      bottom: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      top: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      right: {
                        style: BorderStyle.NIL,
                      },
                    },
                  }),
                  new TableCell({
                    ...C.col(50, [text({ size: 24, text: `Lần ban hành: ${document.docPublishViewVersion}` })]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    borders: {
                      bottom: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      top: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      left: {
                        style: BorderStyle.NIL,
                      },
                    },
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(50, [text({ size: 24, text: `□ Huỷ tài liệu (mã số): ` })]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    borders: {
                      bottom: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      top: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      right: {
                        style: BorderStyle.NIL,
                      },
                    },
                  }),
                  new TableCell({
                    ...C.col(50, [text({ size: 24, text: `Lần ban hành: ${document.docPublishViewVersion}` })]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    borders: {
                      bottom: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      top: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                      left: {
                        style: BorderStyle.NIL,
                      },
                    },
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [text({ size: 24, text: `Tên tài liệu: ${document.Title}` })]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    columnSpan: 2,
                    borders: {
                      top: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                    },
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [text({ size: 24, text: `Lý do soạn thảo/chỉnh sửa/huỷ bỏ: `, italics: true })]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [
                      text({ size: 24, text: `Ý kiến đóng góp của cơ quan/đơn vị liên quan: `, italics: true }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(50, []),
                    borders: {
                      right: {
                        style: BorderStyle.NIL,
                      },
                    },
                  }),
                  new TableCell({
                    ...C.col(50, [
                      text(
                        { size: 24, text: `Ngày......tháng.....năm.... `, italics: true, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text(
                        { size: 24, text: `Thủ trưởng cơ quan/đơn vị đề nghị`, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text({ size: 24, text: ``, break: 5 }, { alignment: AlignmentType.CENTER }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    borders: {
                      left: {
                        style: BorderStyle.NIL,
                      },
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [
                      text(
                        { size: 24, text: "SOÁT XÉT KẾT QUẢ SOẠN THẢO/ CHỈNH SỬA TÀI LIỆU", bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    shading: {
                      fill: "e6e6e6",
                    },
                    borders: {
                      bottom: {
                        style: BorderStyle.DASH_SMALL_GAP,
                      },
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [
                      text({ size: 24, text: "☑ Phù hợp", bold: true }),
                      text({ size: 24, text: "◻ Không phù hợp", bold: true }),
                      text({ size: 24, text: "Lý do nếu đánh giá không phù hợp: ", bold: true }),
                      text({ size: 24, text: ".".repeat(300 - 8), bold: true }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                    },
                    borders: {
                      bottom: {
                        style: BorderStyle.NIL,
                      },
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(50, []),
                    borders: {
                      right: {
                        style: BorderStyle.NIL,
                      },
                      top: {
                        style: BorderStyle.NIL,
                      },
                    },
                  }),
                  new TableCell({
                    ...C.col(50, [
                      text(
                        { size: 24, text: `Ngày......tháng.....năm.... `, italics: true, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text(
                        { size: 24, text: `Thủ trưởng cơ quan/đơn vị soát xét`, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text({ size: 24, text: ``, break: 5 }, { alignment: AlignmentType.CENTER }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    borders: {
                      left: {
                        style: BorderStyle.NIL,
                      },
                      top: {
                        style: BorderStyle.NIL,
                      },
                    },
                    columnSpan: 2,
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(100, [
                      text({ size: 24, text: "KIỂM TRA/PHÊ DUYỆT", bold: true }, { alignment: AlignmentType.CENTER }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                    shading: {
                      fill: "e6e6e6",
                    },
                    columnSpan: 2,
                  }),
                ],
              }),

              new TableRow({
                children: [
                  new TableCell({
                    ...C.col(50, [
                      text(
                        { size: 24, text: `Ngày......tháng.....năm.... `, italics: true, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text(
                        { size: 24, text: `Kiểm tra`, italics: true, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text(
                        { size: 24, text: `(Ký và ghi rõ họ tên)`, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text({ size: 24, text: ``, break: 4 }, { alignment: AlignmentType.CENTER }),
                      text({ size: 24, text: docChecker?.Title, break: 1 }, { alignment: AlignmentType.CENTER }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                  }),
                  new TableCell({
                    ...C.col(50, [
                      text(
                        { size: 24, text: `Ngày......tháng.....năm.... `, italics: true, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text(
                        { size: 24, text: `Phê duyệt `, italics: true, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text(
                        { size: 24, text: `(Ký và ghi rõ họ tên)`, bold: true },
                        { alignment: AlignmentType.CENTER },
                      ),
                      text({ size: 24, text: ``, break: 4 }, { alignment: AlignmentType.CENTER }),
                      text({ size: 24, text: document?.approvedName, break: 1 }, { alignment: AlignmentType.CENTER }),
                    ]),
                    margins: {
                      top: convertInchesToTwip(0.07),
                      bottom: convertInchesToTwip(0.07),
                      left: convertInchesToTwip(0.07),
                      right: convertInchesToTwip(0.07),
                    },
                  }),
                ],
              }),
            ],
          }),
        ],
      },
    ],
  });

  const saveAsDocx = async () => {
    Packer.toBlob(docTempate).then((blob) => {
      saveAs(blob, `V.QMS-F01- YEU CAU SOAN THAO CHINH SUA HUY BO TAI LIEU (${document.Title}).docx`);
      CreateNotification({
        title: "Thông báo",
        body: "Xuất BM01 thành công!",
        icon: "/icons/success.png",
      });
    });
  };

  return (
    document && (
      <>
        <div onClick={saveAsDocx} style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}>
          <FontFa name="faFileWord" size="lg" color={"#0F4C81"} /> V.QMS-F01- YEU CAU SOAN THAO CHINH SUA HUY BO TAI
          LIEU
        </div>
      </>
    )
  );
};
